import { CellState } from '../reducers/cell.reducer';
import { Cell, CellId } from '../types/cell.type';

export const computeSize = (cells: Cell[]): number => {
  if (!assertUniqueType(cells)) {
    return 0;
  }

  return cells
    .map((cell) => {
      switch (cell.type) {
        case 'row':
          return cell.height;
        case 'column':
          return cell.width;
        default:
          return 0;
      }
    })
    .reduce((total, fullWidth) => total + fullWidth, 0);
};

export const assertUniqueType = (cells: Cell[]): boolean => {
  if (cells.length === 0) {
    return true;
  }

  const baseType = cells[0].type;
  return cells.every(({ type }) => type === baseType);
};

export const getCellCoordinates = (
  cellId: CellId,
  cellState: CellState,
  cellsByParent: { [cellId: string]: Cell[] },
): { x: number; y: number } => {
  const cell = cellState.entities[cellId];

  if (cell == null || cell.type === 'root') {
    return { x: 0, y: 0 };
  }

  const siblingCells = cellsByParent[cell.parentId];
  const cellIndex = siblingCells.findIndex(({ id }) => id === cellId);

  const offset = computeSize(siblingCells.slice(0, cellIndex));

  return {
    x: cell.type === 'column' ? offset : 0,
    y: cell.type === 'row' ? offset : 0,
  };
};
